const getRestoTitle = (route, pageName) => pageName

export let client_routes = [
  {
    path: '/client/account/login',
    name: 'clientLogin',
    component: () => import('@/views/client/account/ClientLoginView.vue'),
    meta: { title: 'Client Login' }
  },
  {
    path: '/client/home',
    name: 'clientDashboard',
    component: () => import('@/views/client/ClientDashboardView.vue'),
    meta: { requiresClientAuth: true, title: 'Client Dashboard' }
  },
  {
    path: '/client/account/logout',
    name: 'clientLogout',
    component: () => import('@/views/client/account/ClientLogoutView.vue')
  },
  {
    path: '/client/account/signup',
    name: 'clientSignup',
    component: () => import('@/views/client/account/ClientSignUpView.vue'),
    meta: { title: 'Client Signup' }
  },
  {
    path: '/client/account/forgot_password',
    name: 'clientForgotPassword',
    component: () => import('@/views/client/account/ClientForgotPasswordView.vue'),
    meta: { title: 'Client Forgot Password' }
  },
  {
    path: '/client/account/reset/:token',
    name: 'clientResetPassword',
    component: () => import('@/views/client/account/ClientResetPasswordView.vue'),
    meta: { title: 'Client Reset Password' }
  },
  {
    path: '/client/reset/:token',
    name: 'clientResetPasswordOld',
    meta: { title: 'Client Reset Password' },
    redirect: (to) => {
      return { name: 'clientResetPassword', params: { token: to.params.token } }
    }
  },
  {
    path: '/client/account/setting',
    name: 'clientSetting',
    component: () => import('@/views/client/account/setting/ClientSettingView.vue'),
    meta: { requiresClientAuth: true, title: 'Client Setting' }
  },
  {
    path: '/client/account/update_email',
    name: 'clientUpdateEmail',
    component: () => import('@/views/client/account/setting/ClientUpdateEmailView.vue'),
    meta: { requiresClientAuth: true, title: 'Client Update Email' }
  },
  {
    path: '/client/account/update_password',
    name: 'clientUpdatePassword',
    component: () => import('@/views/client/account/setting/ClientUpdatePasswordView.vue'),
    meta: { requiresClientAuth: true, title: 'Client Update password' }
  },
  {
    path: '/client/resto/:resto_id/home',
    name: 'clientRestoHome',
    component: () => import('@/views/client/ClientHomeView.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, 'Dashboard'),
      permission: null
    }
  },
  {
    path: '/client/resto/:resto_id/edit',
    name: 'clientEditResto',
    component: () => import('@/views/client/resto/EditRestoView.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, 'Edit Restaurant'),
      permission: 'client_setting_crud'
    }
  },
  {
    path: '/client/resto/:resto_id/menu/edit',
    name: 'clientEditMenu',
    component: () => import('@/views/client/menu/EditMenuView.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, 'Edit Menu'),
      permission: 'client_menuedit_crud'
    }
  },
  {
    path: '/client/resto/:resto_id/app_offers',
    name: 'appOffers',
    component: () => import('@/views/client/offer/OfferView.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, 'Marketing'),
      permission: 'client_marketing_crud'
    }
  },
  {
    path: '/client/resto/:resto_id/opening_times',
    name: 'clientOpeningTimes',
    component: () => import('@/views/client/resto/OpeningTimesView.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, 'Opening Times'),
      permission: 'client_collection_delivery_crud'
    }
  },
  {
    path: '/client/resto/:resto_id/orders',
    name: 'clientOrderList',
    component: () => import('@/views/client/order/OrderListView.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, 'Orders'),
      permission: 'client_order_crud'
    }
  },
  {
    path: '/client/resto/:resto_id/epos_orders',
    name: 'clientEposOrderList',
    component: () => import('@/views/client/order/EposOrderListView.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, 'EPOS Orders'),
      permission: 'client_order_crud'
    }
  },
  {
    path: '/client/resto/:resto_id/reservations',
    name: 'clientReservationList',
    component: () => import('@/views/client/ReservationListView.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, 'Reservations'),
      permission: 'client_reservation_crud'
    }
  },
  {
    path: '/client/resto/:resto_id/order/:order_id',
    name: 'clientOrderDetail',
    component: () => import('@/views/client/order/OrderDetailView.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, `Order #${route.params.order_id}`),
      permission: 'client_order_crud'
    }
  },
  {
    path: '/client/resto/:resto_id/epos_order/:order_id',
    name: 'clientEposOrderDetail',
    component: () => import('@/views/client/order/EposOrderDetailView.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, `EPOS Order #${route.params.order_id}`),
      permission: 'client_order_crud'
    }
  },
  {
    path: '/client/resto/:resto_id/manual_customers',
    name: 'clientManualCustomers',
    component: () => import('@/views/client/Manual_Customers/ManualCustomers.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, 'Manual Customers'),
      permission: null
    }
  },
  {
    path: '/client/resto/:resto_id/delivery_settings',
    name: 'clientDeliverySetting',
    component: () => import('@/views/client/DeliverySettingView.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, 'Delivery Settings'),
      permission: 'client_collection_delivery_crud'
    }
  },
  {
    path: '/client/resto/:resto_id/payments',
    name: 'clientPaymentList',
    component: () => import('@/views/client/payment/PaymentListView.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, 'Payments'),
      permission: 'client_payment_crud'
    }
  },
  {
    path: '/client/resto/:resto_id/payment/:payment_id',
    name: 'clientPaymentDetail',
    component: () => import('@/views/client/payment/PaymentDetailView.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, `Payment #${route.params.payment_id}`),
      permission: 'client_payment_crud'
    }
  },
  {
    path: '/client/resto/:resto_id/reports',
    name: 'clientReports',
    component: () => import('@/views/client/ReportsView.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, 'Reports'),
      permission: 'client_reports_crud'
    }
  },
  {
    path: '/client/resto/:resto_id/gift_vouchers',
    name: 'giftVoucherList',
    component: () => import('@/views/client/GiftVoucherView.vue'),
    meta: {
      requiresClientAuth: true,
      title: (route) => getRestoTitle(route, 'Gift Vouchers'),
      permission: null
    }
  },
]
